"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AuButton = _interopRequireDefault(require("../elements/AuButton"));
var _AutoIntl = _interopRequireDefault(require("../elements/AutoIntl"));
var _AuAnalytics = _interopRequireDefault(require("../../utils/AuAnalytics"));
var _context;
var styles = {
  "container": "cookie_banner-module__container___F425A",
  "text": "cookie_banner-module__text___EXiu8",
  "accept": "cookie_banner-module__accept___KDDBs",
  "landscape": "cookie_banner-module__landscape___KJw3v",
  "portrait": "cookie_banner-module__portrait___YwJ90"
};
class CookieBanner extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: !window.localStorage.getItem('acceptedCookieBanner')
    };
  }
  accept = (0, _bind.default)(_context = this.accept).call(_context, this);
  accept() {
    window.localStorage.setItem('acceptedCookieBanner', true);
    this.setState({
      display: false
    });
    _AuAnalytics.default.trackEvent({
      category: 'CookieBanner',
      action: 'Accept'
    });
  }

  /*
   * To reset the local storage past the following into the console:
   *
   * window.localStorage.removeItem('acceptedCookieBanner');
   *
   * Then refresh the browser
   */

  render() {
    if (this.state.display) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: styles.container
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(styles.text, styles.landscape)
      }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: "au.cookieBanner.text"
      }), " ", /*#__PURE__*/_react.default.createElement("a", {
        href: "https://autonomic.ai/privacy/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: "au.cookieBanner.privacyPolicy"
      })), /*#__PURE__*/_react.default.createElement("span", null, ".")), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(styles.text, styles.portrait)
      }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: "au.cookieBanner.mobileText"
      }), " ", /*#__PURE__*/_react.default.createElement("a", {
        href: "https://autonomic.ai/privacy/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
        displayId: "au.cookieBanner.privacyPolicy"
      })), /*#__PURE__*/_react.default.createElement("span", null, ".")), /*#__PURE__*/_react.default.createElement("div", {
        className: styles.accept
      }, /*#__PURE__*/_react.default.createElement(_AuButton.default, {
        type: "primary",
        displayId: "au.cookieBanner.accept",
        onClick: this.accept
      })));
    }
    return false;
  }
}
exports.default = CookieBanner;